import { CartesianGrid, Legend, Area, AreaChart, Tooltip, XAxis, YAxis } from "recharts"

import { diagramColors, IAnalyticsPageDisplayUnit } from "@/types/IAnalytics"


export interface AnalyticsAreaChartProps {
  data: any[] | undefined
  dataKeys: IAnalyticsPageDisplayUnit[]
  colors?: string[]
}

export const AnalyticsAreaChart = (props: AnalyticsAreaChartProps) => {
  const { data, dataKeys, colors } = props

  return (
    <AreaChart width={1400} height={600} data={data}
               margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
      <XAxis dataKey="period"/>
      <YAxis domain={["auto", "auto"]} />
      <Tooltip/>
      <Legend wrapperStyle={{ width: "100%" }} />
      <CartesianGrid stroke="#f5f5f5"/>
      {
        dataKeys.map((data, index) => (
          <Area
            dot={false}
            key={index}
            type="monotone"
            dataKey={data.value}
            name={data.bigLabel}
            stroke={(colors ?? diagramColors)[index]}
            fill={(colors ?? diagramColors)[index]}/>
        ))
      }
    </AreaChart>
  )
}
